import React, { ReactNode } from 'react'

interface ITitleProps {
  children: ReactNode
}

export const Title = (props: ITitleProps) => {
  return <h2 className="ly-leave__tit">{props.children}</h2>
}
